import styled from 'styled-components';

export const EditWrapper = styled.div`
  max-width: 100%;
`;
